import { TemplateExecutor } from 'lodash'

import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { GlobalNavContextInfo } from '../GlobalNav'
import { Account } from '../models'

enum Application {
  Planner = 'Planner',
  AdsManager = 'AdsManager',
  Reports = 'Reports',
  CreativeLibrary = 'Creatives',
  Inventory = 'Inventory',
  QPixel = 'QPixel',
  GlobalSettings = 'GlobalSettings',
  AuthRouting = 'AuthRouting'
}

enum AppSuite {
  Q4mSuite = 'Q4mSuite',
  GlobalSettingsSuite = 'GlobalSettingsSuite',
  AuthRoutingSuite = 'AuthRoutingSuite'
}

enum HeaderTitle {
  ADS = 'ADS',
  AUDIENCES = 'AUDIENCES',
  ASSETS = 'ASSETS'
}

enum Env {
  test = 'test',
  staging = 'staging',
  production = 'production'
}

type AppMapping = {
  [app in Application]?: string
}

type HeaderMapping = {
  [header in HeaderTitle]?: Application[]
}

type HeaderIconMapping = {
  [header in HeaderTitle]?: IconDefinition
}
type URLBuilders = {
  [app in Application]?: TemplateExecutor
}

type AppFlagMapping = {
  [app in Application]?: string | undefined
}

interface Suite {
  APP_DATA_SECTION_MAPPING: AppMapping,
  APP_NAME_MAPPING: AppMapping,
  REQUIRED_APP_FLAGS: AppFlagMapping,
  HEADER_LIST: HeaderTitle[],
  HEADER_ICON_MAPPING: HeaderIconMapping,
  HEADER_MAPPING: HeaderMapping,
  INCLUDE_BANNER_LINK: boolean,
  SHOW_USER_INFO: boolean,
  SHOW_APPS_DROPDOWN: boolean,
  SHOW_ORG_SWITCHER: boolean,
  SHOW_ACCOUNT_SWITCHER: boolean,
  SHOW_PRODUCT_DROPDOWN: boolean,
  SHOW_NOTIFICATION_DROPDOWN: boolean,
  SUITE_NAME: string,
  URL_BUILDERS: URLBuilders,
  URL_MAPPING: AppMapping
}

const APPLICATION_SUITE_MAPPING = {
  [Application.Planner]: AppSuite.Q4mSuite,
  [Application.AdsManager]: AppSuite.Q4mSuite,
  [Application.Reports]: AppSuite.Q4mSuite,
  [Application.CreativeLibrary]: AppSuite.Q4mSuite,
  [Application.Inventory]: AppSuite.Q4mSuite,
  [Application.QPixel]: AppSuite.Q4mSuite,

  [Application.GlobalSettings]: AppSuite.GlobalSettingsSuite,
  [Application.AuthRouting]: AppSuite.AuthRoutingSuite

}

interface GlobalNavConfOptions {
  accountInfo?: Partial<Account>
  elementId?: string
  currentApp?: Application
  onUpdate?: (context: GlobalNavContextInfo) => void
}

interface GlobalNavRenderer {
  render: (configuration: GlobalNavConfOptions) => void
}

interface GlobalNavLoaderType extends GlobalNavRenderer {
  [key: string]: any
}

export {
  Application,
  APPLICATION_SUITE_MAPPING,
  AppSuite,
  AppMapping,
  AppFlagMapping,
  HeaderIconMapping,
  HeaderMapping,
  HeaderTitle,
  Suite,
  Env,
  URLBuilders,
  GlobalNavRenderer,
  GlobalNavLoaderType,
  GlobalNavConfOptions
}

export default Application
